import config from 'config';
import { useState } from 'react';
import { useAppDispatch } from 'reducer';
import { errorAlert, successAlert } from 'reducer/slices/alertSlice';
import { hideLoading, showLoading } from 'reducer/slices/loadingSlice';
import { hidePopup } from 'reducer/slices/popupSlice';
import gather from 'tools/gather';

const Add = ({ data = undefined, reload }: any) => {
  const dispatch = useAppDispatch();
  const [title, setTitle] = useState(data?.title);
  const [text, setText] = useState(data?.text);

  const submit = async () => {
    dispatch(showLoading());

    const result = await gather(`${config.apiUrl}/v1/admin/notif${data ? '/' + data._id : ''}`, true)[data ? 'put' : 'post']({
      title: title,
      text: text,
    });

    if (result.code === 200) {
      dispatch(hidePopup());
      dispatch(successAlert('Done!'));
      reload();
    } else {
      dispatch(errorAlert(result.message ?? 'Not connected to server'));
    }

    dispatch(hideLoading());
  };

  return (
    <div className='login'>
      <div className='inputLogin'>
        <span>Title</span>
        <input type='text' defaultValue={data?.title} onChange={(e) => setTitle(e.target.value)} />
      </div>
      <div className='inputLogin'>
        <span>Text</span>
        <textarea defaultValue={data?.text} onChange={(e) => setText(e.target.value)} />
      </div>
      <div className='submit' onClick={() => submit()}>
        Submit
      </div>
    </div>
  );
};

export default Add;
